/**
 * Server settings' sections, as URL segments (context STORY-0268): `/server/$section`. Out of
 * `server.tsx` so the router can check one without fetching the page's chunk. Add, never rename.
 */
export const SERVER_SECTIONS = [
  'general',
  'branding',
  'trusted-networks',
  'sending-limits',
  'reputation',
  'relay',
  'spam',
  'mta-sts',
  'history',
] as const;
export type ServerSection = (typeof SERVER_SECTIONS)[number];
export const isServerSection = (s: string): s is ServerSection =>
  (SERVER_SECTIONS as readonly string[]).includes(s);
